<template>
  <div ref="imagesContainer" class="images-container">
      <div class="switcher-button switcher-button-left" @click="gotoPrev">
        <el-icon><arrow-left /></el-icon>
      </div>
      <ul class="ul-images" :style="{width: ulWidth, left }">
        <li :style="{width: liWidth}" v-for="(src, index) in srcList" class="image-item">
          <el-image
              style="width: 100%; height: 100%;"
              :src="src"
              :zoom-rate="1.2"
              :max-scale="10"
              :min-scale="3"
              :preview-src-list="srcList"
              :initial-index="index"
              placeholder="图片加载中..."
              fit="cover"
              :hide-on-click-modal="false"
          />
          <el-icon class="image-zoom"><zoom-in /></el-icon>
        </li>
      </ul>
      <div class="switcher-button switcher-button-right" @click="gotoNext">
        <el-icon><arrow-right /></el-icon>
      </div>
  </div>

</template>

<script setup>
import {computed, ref, watch} from "vue";
import {ArrowLeft, ArrowRight, ZoomIn} from "@element-plus/icons-vue";
const props = defineProps({
  srcList: {
    type: Array
  }
})
const imagesContainer = ref()
const ulWidth = ref('0')
const liWidth = ref('0')
// 当前处于中间的图片
const i = ref(2);

const left = computed(() => {
  return (2 - i.value) * parseInt(liWidth.value) + 'px';
})

const gotoNext = () => {
  if(i.value < props.srcList.length - 2){
    i.value += 1;
  }
}

const gotoPrev = () => {
  if(i.value > 2){
    i.value -= 1;
  }
}


watch([imagesContainer, props], (var1) => {
  if(!var1) return null;
  let width = Math.ceil(imagesContainer.value.clientWidth / 3);
  ulWidth.value = `${width *  props.srcList.length}px`;
  liWidth.value = `${width}px`;
})


</script>

<style lang="less" scoped>
.image-item{
  position: relative;
}

.image-zoom{
  position: absolute;
  right: 8px;
  bottom: 8px;
  color: rgba(255, 255,255, .5);
  font-size: 20px;
}

.switcher-button{
  position: absolute;
  top: 0;
  bottom: 0;
  width: 30px;
  font-size: 20px;
  z-index: 1;
  color: rgba(255, 255, 255, 0.6);
  line-height: 300px;
  cursor: pointer;

  &:hover{
    background: linear-gradient(to right, rgba(0, 0, 0, .5), transparent);;
  }

  &-left{
    left: 0;
    background: linear-gradient(to right, rgba(0, 0, 0, .2), transparent);
  }

  &-right{
    right: 0;
    background: linear-gradient(to left,  rgba(0, 0, 0, .2), transparent);
  }
}

.images-container{
  user-select: none;
  width: 100%;
  position: relative;
  overflow: hidden;
}

.ul-images{
  position: absolute;
  height: 100%;
  display: flex;
  flex-direction: row;
  column-gap: 2px;
  transition: linear .5s;
}

.images-container .image-item .el-image-viewer__canvas{
  height: 100%;
}
</style>